import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { AssetCard } from "@10x/dubai-rest-api/dist/property_registry/entity";
import { trackEventWithData } from "@my-dld/utils/Analytics";
import { hideLoading, showLoading, showMessage } from "@my-dld/utils/UIUtils";
import PageContent from "@my-dld/components/PageContent";
import Strings from "@my-dld/assets/strings";
import { extractPropInfo } from "../../MyDLD/PropertyDetails";
import { PvtSellResponse, Terms } from "../../../apis/privatesell/enitites";
import { ArEnName } from "@10x/dubai-rest-api/dist/entities";
import { Redirect } from "react-router";
import { LocaleUtil } from "@eres/core";
import { navigate, replaceNavigate } from "@my-dld/utils/StoreUtils";
import { privateSellApi } from "../../../apis/privatesell";
import { TabuProfile } from "@10x/sso/TabuProfile";
import { DashboardBCItem } from "@my-dld/contexts/PageContext";
import PageTitle from "@my-dld/components/PageTitle";

interface Props extends RoutedViewProps {

}

type TransactionType = "alert-success" | "alert-warning" | "alert-danger";

interface Transaction extends ArEnName {
	type: TransactionType;
}

interface State {
	isLoading: boolean;
	tabuProperty: AssetCard;
	transactions?: Transaction[];
	listOption?: Terms[];
	canContinue: boolean;
}

export default class PropertyTransaction extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {
			isLoading: true,
			canContinue: false,
			tabuProperty: props.location.state ? props.location.state.property : undefined,
			transactions: [],
		};
	}

	componentDidMount(): void {
		this.validateProperty();
	}

	validateProperty = () => {
		const { tabuProperty } = this.state;
		const p = TabuProfile.getProfile();
		if ( tabuProperty && p ) {
			showLoading();
			let propertyID = tabuProperty.tabuPropertyId ? ( tabuProperty.tabuPropertyId + "" ) : "";
			const apiHandler = ( response: PvtSellResponse ) => {
				hideLoading();
				this.setState( {
					isLoading: false,
					canContinue: canContinue( response ),
					transactions: extractTransactions( response ),
					listOption: response.termsAndConditions,
				} );
				if ( this.state.canContinue ) {
					trackEventWithData( "PrivateSell", "ValidateProperty", { propertyID: propertyID } );
				} else {
					let errorMsg = "";
					for ( let error of response.errors ) {
						if ( error.errorMessageSet ) {
							errorMsg = errorMsg + "\n" + error.errorMessageSet.englishName;
						}
					}
					trackEventWithData( "PrivateSell", "ValidatePropertyFailed", {
						propertyID: propertyID,
						error: errorMsg,
					} );
				}
			};
			const apiExHandler = ( reason: any ) => {
				hideLoading();
				this.setState( { isLoading: false } );
				if ( reason && reason.type && reason.type === "ValidationError" ) {
					showMessage( Strings.system_error );
					trackEventWithData( "PrivateSell", "ValidatePropertyFailed", {
						propertyID: propertyID,
						error: Strings.system_error,
					} );
				} else {
					showMessage( reason.toString() );
					trackEventWithData( "PrivateSell", "ValidatePropertyFailed", {
						propertyID: propertyID,
						error: reason.toString(),
					} );
				}
			};
			privateSellApi.validatePropertyForPrivateSell( tabuProperty.tabuPropertyId.toString(),
				p.tabuParticipantId!.toString(), tabuProperty.propertyTypeId ).then( apiHandler ).catch( apiExHandler );
		} else {
			this.setState( { isLoading: false } );
		}

	};

	render() {
		const { tabuProperty, transactions, isLoading } = this.state;
		if ( tabuProperty == null )
			return <Redirect to={ "/mydld" }/>;
		const { val, lbl } = extractPropInfo( tabuProperty );
		return <PageContent
			title={ `${ Strings.sell_property } - ${ lbl } : ${ val }` }
			hideQLinks={ true }>
			<PageTitle title={ Strings.sell_property } paths={ [ DashboardBCItem ] }/>
			<div className="section-title"><h5>{ Strings.transactions }</h5></div>
			{
				!isLoading && <>
					{
						!transactions &&
						<div className={ "mt-3 mb-3 alert alert-user-notification alert-success" } style={ { width: "fit-content" } }>
							<div className="alert-body">
								<p className="mb-0">{ Strings.no_data_available }</p>
							</div>
						</div>
					}
					{
						transactions && transactions.length === 0 &&
						<div className={ "mt-3 mb-3 alert alert-user-notification alert-success" } style={ { width: "fit-content" } }>
							<div className="alert-body">
								<p className="mb-0">{ Strings.no_data_available }</p>
							</div>
						</div>
					}
					{
						transactions?.map( transaction => {
							const clssName = "mt-3 mb-3 alert alert-user-notification " + transaction.type;
							return <div className={ clssName } style={ { width: "fit-content" } }>
								<div className="alert-body">
									<p className="mb-0">{ LocaleUtil.getLocalValue( transaction ) }</p>
								</div>
							</div>;
						} )
					}
					<div>
						{
							this.state.canContinue && <button className="btn btn_1" type="button" onClick={ this.proceed }>
								{ Strings.proceed }
							</button>
						}
						<a onClick={ this.backToPage } className="btn btn-grey btn_style1 ms-2 me-2">{ Strings.close_label }</a>
					</div>
				</>
			}


		</PageContent>;
	}

	proceed = () => {
		const { tabuProperty, transactions, listOption } = this.state;
		const tabuPropertyID = tabuProperty.propertyId;
		navigate( `/mydld/privateSell/${ tabuPropertyID }`, undefined, {
			property: tabuProperty,
			transactions: transactions,
			listOption: listOption,
		} );
	};
	backToPage = () => {
		const property = this.state.tabuProperty;
		replaceNavigate( "/mydld/" + "property/" + property.propertyTypeId + "/" + property.tabuPropertyId );
	};


}

function canContinue( response: PvtSellResponse ): boolean {
	if ( response && response.errors && response.errors.length > 0 ) {
		let errors = response.errors;
		for ( let i = 0; i < errors.length; i++ ) {
			let error = errors[ i ];
			let type = error.validationType;
			if ( type === 2 || type === 3 ) return false;
		}
	}
	return true;
}

function extractTransactions( response: PvtSellResponse ): Transaction[] {
	const tr: Transaction[] = [];
	if ( response && response.errors && response.errors.length > 0 ) {
		let errors = response.errors;
		for ( let i = 0; i < errors.length; i++ ) {
			let error = errors[ i ];
			let type = error.validationType;
			let tt: TransactionType = "alert-danger";
			if ( type === 2 || type === 3 ) {
				tt = "alert-danger";
			} else if ( type === 4 ) {
				tt = "alert-warning";
			} else {
				tt = "alert-success";
			}
			tr.push( {
				...error.errorMessageSet,
				type: tt,
			} as Transaction );
		}
	}
	return tr;
}
